import { render } from "./AttributeWrapper.vue?vue&type=template&id=641ef695"
import script from "./AttributeWrapper.vue?vue&type=script&lang=js"
export * from "./AttributeWrapper.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AttributeWrapper.vue?vue&type=style&index=0&id=641ef695&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__